import SEOMeta from '@/components/base/SEOMeta';
import Breadcrumb from '@/components/base/Breadcrumb';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '吃瓜网的内容多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网保持全天候实时更新，我们的编辑团队7×24小时追踪娱乐圈最新动态，确保您第一时间获取最劲爆的娱乐资讯。重大爆料和突发事件会在30分钟内上线。',
      },
    },
    {
      '@type': 'Question',
      name: '吃瓜网的爆料内容可信吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网坚持真实性原则，所有爆料内容均经过多渠道交叉验证。我们拥有专业的调查团队和广泛的行业人脉，致力于为读者提供真实可靠的娱乐资讯。对于未经证实的传闻，我们会明确标注"传闻"或"待核实"。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向吃瓜网提供爆料线索？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过以下方式向我们提供爆料线索：发送邮件至 tips@chigua.com，或通过微信公众号、微博私信联系我们。我们会对爆料人信息严格保密，并对有价值的线索提供丰厚奖励。',
      },
    },
    {
      '@type': 'Question',
      name: '吃瓜网的内容可以转载吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网的所有原创内容受版权保护。如需转载，请通过官方邮箱 contact@chigua.com 联系我们获取授权。未经授权的转载行为，我们将保留追究法律责任的权利。',
      },
    },
    {
      '@type': 'Question',
      name: '吃瓜网有手机APP吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网目前提供移动端适配的网页版本，您可以通过手机浏览器访问获得完整的阅读体验。同时，您也可以关注我们的微信公众号和小程序，随时随地畅享吃瓜乐趣。APP版本正在开发中，敬请期待。',
      },
    },
  ],
};

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于吃瓜网',
  description: '吃瓜网是领先的中文娱乐八卦资讯平台，致力于为读者提供最新、最全、最劲爆的娱乐资讯。',
  url: 'https://chigua.com/about',
};

const statColorMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600' },
};

export default function AboutPage() {
  return (
    <>
      <SEOMeta
        title="关于我们"
        description="吃瓜网是领先的中文娱乐八卦资讯平台，致力于为读者提供最新、最全、最劲爆的娱乐资讯。了解我们的品牌故事、团队实力和联系方式。"
        keywords="关于吃瓜网,吃瓜网介绍,联系方式,品牌故事"
        canonicalUrl="https://chigua.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="mb-12" aria-label="品牌介绍">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            关于吃瓜网
          </h1>
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <p className="text-foreground-700 leading-relaxed mb-4">
              <strong className="text-foreground-950">吃瓜网</strong>成立于2020年，是国内领先的中文娱乐八卦资讯平台。我们以"让每个人都能畅快吃瓜"为使命，致力于为读者提供最新、最全、最劲爆的娱乐资讯。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              经过多年的深耕发展，吃瓜网已经建立起覆盖明星八卦、影视综艺、网红爆料、社会热点等多个领域的全方位内容体系。我们的编辑团队由资深娱乐记者和行业分析师组成，拥有丰富的行业经验和广泛的人脉资源。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              截至2026年，吃瓜网月活跃用户已突破<strong className="text-foreground-950">5000万</strong>，日均内容更新量超过<strong className="text-foreground-950">200篇</strong>，稳居中文娱乐资讯平台第一梯队。我们不仅是一个信息平台，更是亿万吃瓜群众的精神家园。
            </p>
          </div>
        </section>

        <section className="mb-12" aria-label="口碑信誉">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            口碑与信誉
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: 'ri-shield-check-line', color: 'accent', number: '99.7%', label: '内容真实率' },
              { icon: 'ri-user-heart-line', color: 'primary', number: '5000万+', label: '月活跃用户' },
              { icon: 'ri-award-line', color: 'secondary', number: '12项', label: '行业大奖' },
              { icon: 'ri-thumb-up-line', color: 'accent', number: '98%', label: '用户好评率' },
            ].map((stat, index) => {
              const colors = statColorMap[stat.color] || statColorMap.primary;
              return (
              <div key={index} className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center">
                <div className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full ${colors.bg}`}>
                  <i className={`${stat.icon} text-lg ${colors.text}`}></i>
                </div>
                <div className="text-2xl font-bold text-foreground-950 mb-1">{stat.number}</div>
                <div className="text-sm text-foreground-500">{stat.label}</div>
              </div>
              );
            })}
          </div>

          <div className="mt-6 bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <h3 className="text-lg font-semibold text-foreground-950 mb-4">我们的承诺</h3>
            <ul className="space-y-3">
              {[
                { icon: 'ri-checkbox-circle-line', text: '坚持原创内容，杜绝抄袭洗稿' },
                { icon: 'ri-checkbox-circle-line', text: '严格事实核查，确保信息准确' },
                { icon: 'ri-checkbox-circle-line', text: '保护爆料人隐私，绝不泄露信源' },
                { icon: 'ri-checkbox-circle-line', text: '尊重当事人权益，拒绝恶意诽谤' },
                { icon: 'ri-checkbox-circle-line', text: '及时更正错误，勇于承担责任' },
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-foreground-700">
                  <i className={`${item.icon} text-primary-500 mt-0.5`}></i>
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="mb-12" aria-label="联系方式">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-3">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">商务合作</h3>
              <p className="text-sm text-foreground-500 mb-2">广告投放、品牌合作、内容共建</p>
              <a href="mailto:biz@chigua.com" className="text-sm text-primary-500 hover:text-primary-600 font-medium">
                biz@chigua.com
              </a>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-3">
                <i className="ri-spy-line text-lg text-accent-700"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">爆料投稿</h3>
              <p className="text-sm text-foreground-500 mb-2">提供线索、独家爆料，严格保密</p>
              <a href="mailto:tips@chigua.com" className="text-sm text-accent-600 hover:text-accent-700 font-medium">
                tips@chigua.com
              </a>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 mb-3">
                <i className="ri-customer-service-line text-lg text-secondary-700"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">客服热线</h3>
              <p className="text-sm text-foreground-500 mb-2">7×24小时贴心服务</p>
              <a href="tel:400-888-6666" className="text-sm text-secondary-600 hover:text-secondary-700 font-medium">
                400-888-6666
              </a>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-3">
                <i className="ri-map-pin-line text-lg text-primary-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">公司地址</h3>
              <p className="text-sm text-foreground-500">
                北京市朝阳区星光大道88号<br />
                吃瓜大厦18层
              </p>
            </div>
          </div>
        </section>

        <section className="mb-12" aria-label="常见问题">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <div className="space-y-3">
            {[
              { q: '吃瓜网的内容多久更新一次？', a: '吃瓜网保持全天候实时更新，我们的编辑团队7×24小时追踪娱乐圈最新动态，确保您第一时间获取最劲爆的娱乐资讯。重大爆料和突发事件会在30分钟内上线。' },
              { q: '吃瓜网的爆料内容可信吗？', a: '吃瓜网坚持真实性原则，所有爆料内容均经过多渠道交叉验证。我们拥有专业的调查团队和广泛的行业人脉，致力于为读者提供真实可靠的娱乐资讯。对于未经证实的传闻，我们会明确标注"传闻"或"待核实"。' },
              { q: '如何向吃瓜网提供爆料线索？', a: '您可以通过以下方式向我们提供爆料线索：发送邮件至 tips@chigua.com，或通过微信公众号、微博私信联系我们。我们会对爆料人信息严格保密，并对有价值的线索提供丰厚奖励。' },
              { q: '吃瓜网的内容可以转载吗？', a: '吃瓜网的所有原创内容受版权保护。如需转载，请通过官方邮箱 contact@chigua.com 联系我们获取授权。未经授权的转载行为，我们将保留追究法律责任的权利。' },
              { q: '吃瓜网有手机APP吗？', a: '吃瓜网目前提供移动端适配的网页版本，您可以通过手机浏览器访问获得完整的阅读体验。同时，您也可以关注我们的微信公众号和小程序，随时随地畅享吃瓜乐趣。APP版本正在开发中，敬请期待。' },
            ].map((faq, i) => (
              <details key={i} className="bg-background-50 rounded-xl border border-background-200/70 group">
                <summary className="p-5 cursor-pointer flex items-center justify-between text-foreground-950 font-semibold text-sm md:text-base">
                  <span>{faq.q}</span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}